import { render, staticRenderFns } from "./addNewUserV2.vue?vue&type=template&id=9f91a326&scoped=true&"
import script from "./addNewUserV2.vue?vue&type=script&lang=ts&"
export * from "./addNewUserV2.vue?vue&type=script&lang=ts&"
import style0 from "./addNewUserV2.vue?vue&type=style&index=0&id=9f91a326&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f91a326",
  null
  
)

export default component.exports